import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Alert,
  Container,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Routes as AppRoutes } from '../../../routes';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';

const InvitationErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box mt={8}>
        <Card elevation={3}>
          <CardContent sx={{ textAlign: 'center', p: 4 }}>
            <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />

            <Typography variant="h5" gutterBottom color="error">
              Invalid Invitation
            </Typography>

            <Alert severity="error" sx={{ mt: 2, mb: 3, textAlign: 'left' }}>
              This invitation link is invalid or has expired.
            </Alert>

            <Typography variant="body1" sx={{ mb: 3 }} color="text.secondary">
              Possible reasons:
            </Typography>

            <Box sx={{ textAlign: 'left', mb: 3 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                • The invitation has already been used
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                • The invitation link has expired
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                • The invitation was cancelled
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • The link may be incomplete or incorrect
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ mb: 4 }} color="text.secondary">
              Please contact your administrator to request a new invitation.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate(AppRoutes.root)}
              data-testid="go-to-login-button"
            >
              Go to Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default InvitationErrorPage;
